import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from '../pages/Dashboard';
import DocumentList from '../pages/DocumentList';
import DocumentUpload from '../pages/DocumentUpload';
import DocumentView from '../pages/DocumentView';
import Search from '../pages/Search';
import Chat from '../pages/Chat';
import WeChatArticle from '../pages/WeChatArticle';
import UserManagement from '../pages/UserManagement';
import DepartmentManagement from '../pages/DepartmentManagement';
import AuditLogManagement from '../pages/AuditLogManagement';
import SystemConfig from '../pages/SystemConfig';
import ApiTest from '../ApiTest';

const AppRoutes: React.FC = () => (
  <Routes>
    <Route path="/" element={<Dashboard />} />
    <Route path="/documents" element={<DocumentList />} />
    <Route path="/documents/:id" element={<DocumentView />} />
    <Route path="/upload" element={<DocumentUpload />} />
    <Route path="/search" element={<Search />} />
    <Route path="/chat" element={<Chat />} />
    <Route path="/wechat-article" element={<WeChatArticle />} />
    <Route path="/users" element={<UserManagement />} />
    <Route path="/departments" element={<DepartmentManagement />} />
    <Route path="/audit-logs" element={<AuditLogManagement />} />
    <Route path="/system-config" element={<SystemConfig />} />
    <Route path="/api-test" element={<ApiTest />} />
    <Route path="/system-monitor" element={<Navigate to="/" replace />} />
  </Routes>
);

export default AppRoutes;
